import axios from 'axios';

export const getADTAlertAvailableProviders = (practiceId) => (
	axios.get(`/provider_practices/${practiceId}/practice-adt-alert-available-providers`)
);

export const setADTAlertAvailableProvider = (practiceId, providerId, available = false) => (
	axios.post(`/provider_practices/${practiceId}/practice-set-adt-alert-available-provider`, {
		providerId,
		availableInd: available
	})
);
